import React, { useState } from 'react';

import { Button } from '../../../../design-system';
import SuccessAlert from '../../../../design-system/SuccessAlert/SuccessAlert';
import WebhookNotificationCard from '../WebhookNotificationCard/WebhookNotificationCard';
import WebhookNotificationModal from '../WebhookNotificationModal/WebhookNotificationModal';

const WebhookNotificationsBlock = ({ agentId, webhookNotifications, setWebhookNotifications }) => {
    const areWebhookNotifications = !!webhookNotifications?.length;

    const [notificationModal, setNotificationModal] = useState(null);
    const [successAlert, setSuccessAlert] = useState(null);

    const updateNotificationInState = (updatedNotification) => {
        setWebhookNotifications(
            (prevNotifications) =>
                prevNotifications?.map((notification) =>
                    notification.id === updatedNotification.id
                        ? { ...notification, ...updatedNotification }
                        : notification
                ) || []
        );
    };

    return (
        <div className="flex flex-col gap-3">
            {areWebhookNotifications && (
                <div className="flex flex-col gap-2">
                    {webhookNotifications.map((notification) => (
                        <WebhookNotificationCard
                            key={notification.id}
                            agentId={agentId}
                            notification={notification}
                            setNotificationModal={setNotificationModal}
                            updateNotificationInState={updateNotificationInState}
                            setWebhookNotifications={setWebhookNotifications}
                            setSuccessAlert={setSuccessAlert}
                        />
                    ))}
                </div>
            )}

            {!areWebhookNotifications && (
                <p className="font-body-bold text-body-bold-xs text-neutral-500">
                    Click “Add New” to add a notification
                </p>
            )}

            <div className="flex justify-end">
                <Button
                    type="primary"
                    size="sm"
                    text="Add New"
                    onClick={() => setNotificationModal({ mode: 'create' })}
                />
            </div>

            {notificationModal && (
                <WebhookNotificationModal
                    agentId={agentId}
                    mode={notificationModal.mode}
                    data={notificationModal.data}
                    setWebhookNotifications={setWebhookNotifications}
                    updateNotificationInState={updateNotificationInState}
                    onClose={() => setNotificationModal(null)}
                />
            )}

            <SuccessAlert successAlert={successAlert} setSuccessAlert={setSuccessAlert} />
        </div>
    );
};

export default WebhookNotificationsBlock;
